<template>
  <div>
    <el-form-item v-if="!multiple" :prop="current" :label="labels[type]">
      <el-input
        :id="current"
        placeholder="请输入"
        v-model="formData[current]"
      ></el-input>
    </el-form-item>
    <multi-input
      v-else
      v-model="formData[multipleKey]"
      :prop="multipleKey"
      :label="labels[type]"
      :rules="rules[current]"
      :count="count"
    >
    </multi-input>
  </div>
</template>

<script>
//
import MultiInput from './multi-input';

export default {
  components: {
    MultiInput
  },
  props: {
    type: {
      type: [Number, String],
      default: 0
    },
    types: Array,
    labels: Array,
    multiple: Boolean,
    multiPrefix: {
      type: String,
      default: ''
    },
    formData: Object,
    count: [Number, String],
    rules: Object,
    unit: {
      type: String,
      default: '年'
    },
    defaultValue: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    current() {
      return this.types[this.type];
    },
    multipleKey() {
      if (!this.multiPrefix) {
        return this.current;
      }
      const first = this.current[0];
      const key = `${
        this.multiPrefix
      }${first.toUpperCase()}${this.current.slice(1)}`;
      //console.log('multipleKey', key);
      return key;
    }
  },
  methods: {}
};
</script>
